import { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { setL2Visible } from 'Deer/slice/DeerNav.slice';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { SurveyCreationContent } from './SurveyCreationContent';
import { SurveyCreationHeader } from './SurveyCreationHeader';
import { SurveyCreationPresets } from './SurveyCreationPresets';
import { SurveyCreationLoader } from './components/SurveyCreationLoader';
import { useGetSurveyForm } from './dataHook';

export const SurveyCreation = () => {
  const dispatch = useDispatch();
  const { surveyId } = useParams() as { surveyId: string };
  const isPresetsPage = surveyId === 'presets';
  const {
    data: surveyForm,
    isLoading: isSurveyFormLoading,
    isError: isSurveyFormError,
  } = useGetSurveyForm(surveyId, !isPresetsPage);

  // close L2 menu when this component is mounted
  useEffect(() => {
    dispatch(setL2Visible({ isL2Visible: false }));
    return () => {
      dispatch(setL2Visible({ isL2Visible: true }));
    };
  }, [dispatch]);

  if (isSurveyFormLoading && !isPresetsPage) return <SurveyCreationLoader />;

  if (!surveyId || isSurveyFormError) return null;

  const { currentStage, selectedFilters, totalEmployeeCount, revieweeSelectionType } = surveyForm || {};

  if (isPresetsPage) {
    return (
      <Flex flexDir="column" h="calc(100vh - 12px - 8px)">
        <SurveyCreationHeader />
        <SurveyCreationPresets />
      </Flex>
    );
  }

  return (
    <Flex flexDir="column" h="calc(100vh - 12px - 8px)">
      <SurveyCreationHeader />
      <SurveyCreationContent
        surveyId={surveyId}
        surveyName={surveyForm.name}
        isReadOnly={currentStage !== 'DRAFT'}
        selectedFilters={selectedFilters}
        totalEmployeeCount={totalEmployeeCount}
        revieweeSelectionType={revieweeSelectionType}
      />
    </Flex>
  );
};
